module.exports = __webpack_public_path__ + "img/02-马拉松.9555f587.jpg";